<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5 p-2">
      <div class="card-panel-box bg-white p-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <small class="fw-bolder"><span>تدوین ارکان جهت ساز</span> / <span>تصویر سازی آینده    </span>  </small>
          <button class="btn btn-primary btn-submit-1"
                  @click="$router.go(-1)">برگشت
          </button>
        </div>
      </div>
       <Component v-for="item in items" :type="item"/>
      <hr class="mt-2 mb-2">
      <div class="d-flex justify-content-between">
        <p @click.prevent="previousPage" class="btn btn-submit-1 btn-primary">مرحله قبلی</p>
        <p @click.prevent="nextPage" class="btn btn-submit-1 btn-primary">مرحله بعدی</p>
      </div>
    </div>

  </div>

</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";
import  Component from  './components_Vision_working_group_future_ByType/Component.vue'

const toast = useToast();

export default {
  name: 'HomeView',
  components: {
    Reset,
    Sidebar,
    Component,
    splash
  },
  data() {
    return {
      id_route: this.$route['params']['id'],
      name_route: '',
      items: [1,2,3,4,5,6]


    }
  },
  methods: {


    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    },


    previousPage() {

      router.push('/Vision_working_group_Gary_Hamel_questionnaire/ByType')


    },
    nextPage() {

      router.push(`/Vision_working_group_Suggested_perspective`)


    },


  },
  mounted() {
    this.checkIsMother()

  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3 {
  font-size: 1.3vw !important;
}

small {
  font-size: 1vw !important;
}

textarea {
  height: 6vw !important;
}
</style>